interface SelectedTasks {
	id: string;
	externalReferences: string[];
	systemName: string;
	category?: string;
	resolved: boolean;
}

export function holdUntilExternalReferencesAreResolved(task: SelectedTasks, siblings: SelectedTasks[], interventionTasks: SelectedTasks[]) {
	if (!task.externalReferences || task.externalReferences.length === 0) {
		return false;
	}

	const referencedDocumentationNames = task.externalReferences;
	const siblingSystemNames = siblings.map(x => x.systemName);

	if (referencedDocumentationNames.every(ref => siblingSystemNames.includes(ref) || siblingSystemNames.includes(ref.split('-')[0]))) {
		return false;
	}

	const referencedTasks = interventionTasks.filter(
		x =>
			(referencedDocumentationNames.includes(x.systemName) || referencedDocumentationNames.includes(x.systemName.split('-')[0])) &&
			x.category !== task.category
	);

	return referencedTasks.some(refTask => !refTask.resolved);
}
